import { Box, CircularProgress } from '@mui/material';

interface PageFallbackProps {
  /** Full viewport (before the shell mounts) or the content area only. */
  fullScreen?: boolean;
}

/** Loading state shown while a route chunk or the tenant layout loads. */
export function PageFallback({
  fullScreen = false,
}: PageFallbackProps): JSX.Element {
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-label="carregando"
      sx={{
        height: fullScreen ? '100vh' : '60vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
}
